import { deviceList } from '@/mocks/movies';

export default function Device() {
  return (
    <section id="device" className="w-full bg-secondary-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-secondary-700 text-xs md:text-sm font-medium tracking-wide">
            <i className="ri-device-line" />
            多端适配
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 text-balance">
            手机版、平板、电脑与电视怎么看
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            同一个页面在不同设备上的排版会有所区别。下面把四种常见设备的浏览方式分别说明，
            你可以对照自己常用的设备，判断哪一种更顺手。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {deviceList.map((d) => (
            <article
              key={d.name}
              className="flex flex-col rounded-lg bg-background-50 border border-secondary-200/70 p-5 md:p-6"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-2xl">
                <i className={d.icon} />
              </div>
              <h3 className="mt-4 font-heading font-semibold text-base md:text-lg text-foreground-950">
                {d.name}
              </h3>
              <p className="mt-2.5 text-foreground-600 text-xs md:text-sm leading-relaxed flex-1">
                {d.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 self-start px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-[11px] md:text-xs font-medium">
                <i className="ri-check-double-line" />
                {d.tag}
              </span>
            </article>
          ))}
        </div>

        <div className="mt-6 rounded-lg bg-background-50 border border-secondary-200/70 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
          <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 text-xl shrink-0">
            <i className="ri-lightbulb-line" />
          </div>
          <p className="text-foreground-700 text-xs md:text-sm leading-relaxed">
            手机上如果需要长时间浏览，建议把页面添加到主屏幕，之后像使用应用一样一点即开；
            电脑端则可以同时打开多个标签页，方便在片单与说明之间来回对照。
          </p>
        </div>
      </div>
    </section>
  );
}